import { z } from "zod";

export const schema = z.object({
	id_tipocliente: z.number().int("Campo id_empresa é obrigatorio"),
	nome: z.string().min(1, "Descrição do centro custo é obrigatório"),
	ativo: z.boolean(),
	obs: z.string().nullable(),
});
